
import { Options, Vue } from "vue-class-component";
import { PropType } from "vue";
import Field from "@/entities/Contracts/Field";

@Options({
  emits: ["onEditField", "onDeleteField"],
  props: {
    fields: {
      type: Array as PropType<Field[]>,
    },
    showActions: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
})
export default class TurretForm extends Vue {
  editField(field: Field): void {
    this.$emit("onEditField", field);
  }

  deleteField(field: Field): void {
    this.$emit("onDeleteField", field);
  }
}
